import { RefObject, useLayoutEffect, useState } from 'react';

export function useTextOverflow(
  ref: RefObject<HTMLElement>,
  text: string,
  expanded: boolean
): boolean {
  const [overflows, setOverflows] = useState(false);

  useLayoutEffect(() => {
    if (expanded) {
      return;
    }

    const el = ref.current;
    if (!el) {
      return;
    }

    const checkOverflow = () => {
      setOverflows(el.scrollHeight > el.clientHeight);
    };

    checkOverflow();

    window.addEventListener('resize', checkOverflow);
    const resizeObserver = typeof ResizeObserver !== 'undefined'
      ? new ResizeObserver(checkOverflow)
      : null;

    if (resizeObserver) {
      resizeObserver.observe(el);
    }

    return () => {
      window.removeEventListener('resize', checkOverflow);
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, [ref, text, expanded]);

  return overflows;
}
